/*
 * @Author: zhangdingsong
 * @LastEditTime: 2024-11-13 10:26:16
 */
import {
  HomeBannerAndRecommendMoule,
  HomeMoules,
  VideoCourseItem,
} from "@root/common/interface/result";
import {
  getCategroyCourseList,
  getHomemMoudles,
  querSaveUserWatchTime,
} from "@root/common/service";

import { Card, Carousel, Col, message, Row, Modal } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import "./_style.scss";
import entryIcon from "@root/img/entry.png";
import { useNavigate } from "react-router-dom";
import { RootState, store } from "@root/store";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setRegisterType } from "@root/reducers/register";

import ShowConfirm from "@root/pages/index/showConfirm/index";
import ConfirmUserInfo from "@root/pages/home/confirmUserInfo/index";
import { PopAdvertisement } from "@root/components/popAdvertisement";
import {
  postLeaveAdvertisementTime,
  postLeaveAdvertisementTimeMap,
} from "@root/common/utils";
import { start } from "repl";
import { setBannerInfo } from "@root/reducers/banner";
export default function Portal() {
  var startTime = new Date().valueOf() / 1000;
  const dispatch = useDispatch();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmUserInfo, setShowConfirmUserInfo] = useState(false);
  const [modules, setModules] = useState<HomeMoules>();
  const [curBannerItem, setCurBannerItem] =
    useState<HomeBannerAndRecommendMoule>();
  const navigate = useNavigate();
  const { access_token, userDetailInfo } = useSelector(
    (item: RootState) => item.userInfo
  );
  const {
    xy_home_banner,
    xy_home_erect,
    xy_home_pop,
    xy_home_slip,
    xy_home_bottom,
  } = useSelector((state: RootState) => state.advertisementData);
  const [videoCoursesList, setVideoCoursesList] = useState<VideoCourseItem[]>();
  const queryHomemMenus = async () => {
    const { data } = await getHomemMoudles();
    setModules(data);

    const {
      data: { rows = [] },
    } = await getCategroyCourseList(null, { pageNum: 1, pageSize: 8 });
    setVideoCoursesList(rows);
  };
  /**
   * 进入首页调用接口保存状态
   */
  const saveHomePageSaveEnterInerface = () => {
    let data = [
      {
        sourceType: 4,
        sourceId: 1,
        sourceName: "首页",
      },
    ];
    const {
      userInfo: { uumsId = "" },
    } = store.getState();
    const leaveTime = Math.floor(new Date().valueOf() / 1000 - startTime);
    data.length && querSaveUserWatchTime(data, leaveTime, uumsId, 2);
  };
  useEffect(() => {
    queryHomemMenus();
  }, []);
  useEffect(() => {
    saveHomePageSaveEnterInerface();
  }, []);
  useEffect(() => {
    setCurBannerItem(xy_home_banner[0]);
  },[])
  const dateFormat = (dateTime: number) => {
    return moment(dateTime).format("YYYY-MM-DD");
  };

  const onChange = (slideIndex: number) => {
    setCurBannerItem(xy_home_banner[slideIndex]);
  };

  const onNewsListClick = (columnId: number) => {
    navigate(`/news/list/${columnId}`);
  };

  const onNewsDetailsClick = (item: any) => {
    var startTime = new Date().valueOf() / 1000;
    let newsList = [
      {
        id: item.newsId,
        title: item.title,
      },
    ];
    postLeaveAdvertisementTimeMap(newsList, startTime, newsList.length, 2, 2);
    navigate(`/news/details/${item.newsId}`);
  };

  const onVideoCoursesMoreClick = () => {
    navigate(`/home/COVID-19`);
  };

  const onVideoCourseClick = (videoId: number) => {
    if (access_token) {
      if (userDetailInfo && userDetailInfo.status !== "0") {
        message.info("审核通过后才能观看视频");
        return;
      }
      navigate(`/play?courseId=${videoId}`);
    } else {
      message.info("请登录后学习课程");
    }
  };
  useEffect(() => {
    return () => {
      const advertisementMap = [...xy_home_bottom, ...xy_home_erect];
      postLeaveAdvertisementTime(advertisementMap, startTime);
      postLeaveAdvertisementTimeMap(
        xy_home_banner,
        startTime,
        xy_home_banner.length,
        1
      );
    };
  }, []);
  return (
    <div className="cotainer">
      <div className="portal-conver">
        {/* 轮播区 */}
        {xy_home_erect.length > 0 && (
          <img
            src={xy_home_erect[0].imageUrl}
            alt=""
            className="xy_home_erect_left"
            onClick={() => {
              xy_home_erect[0].url && window.open(xy_home_erect[0].url);
            }}
          />
        )}
        {xy_home_erect.length > 0 && (
          <img
            src={xy_home_erect[0].imageUrl}
            alt=""
            className="xy_home_erect_right"
            onClick={() => {
              xy_home_erect[0].url && window.open(xy_home_erect[0].url);
            }}
          />
        )}
        <Row>
          <Col span={14} className="banner-module">
            <Carousel
              autoplay
              autoplaySpeed={2000}
              // draggable
              afterChange={onChange}
              dots={{ className: "banner-custom-dots" }}
            >
              {xy_home_banner.length > 0 &&
                xy_home_banner.map((bannerItem: any) => {
                  return (
                    <div
                      className="banner-item"
                      onClick={async () => {
                        postLeaveAdvertisementTimeMap(
                          xy_home_banner,
                          startTime,
                          xy_home_banner.length,
                          1,
                          2
                        );
                        if (bannerItem.urlParameter === "iframe") {
                          // 存储banner信息
                          dispatch(
                            setBannerInfo({
                              url: bannerItem.url,
                              title: bannerItem.title,
                            })
                          );
                          navigate(`/iframeComponent`);
                        } else if (bannerItem.url.includes("/needLogin")) {
                          dispatch(setRegisterType("banner"));
                          setShowConfirm(true);
                        } else if(bannerItem.url.includes("compreImprovement")){
                          navigate(`/home/compreImprovement`);
                        }else{
                          bannerItem.url && window.open(bannerItem.url);
                        }
                      }}
                    >
                      <img src={bannerItem.imageUrl} alt="" />
                    </div>
                  );
                })}
            </Carousel>
            <div className="banner-item-title">
              <span>{curBannerItem && curBannerItem.title}</span>
            </div>
          </Col>
          <Col span={10} className="recommend-module">
            {modules?.recommend &&
              modules?.recommend.slice(0, 4).map((recommendItem) => {
                return (
                  <div
                    className="new-item"
                    onClick={() => onNewsDetailsClick(recommendItem)}
                    key={recommendItem.newsId}
                  >
                    <p>
                      <span className="new-title">
                        {recommendItem.title.length >= 42
                          ? recommendItem.title.slice(0, 42) + "... "
                          : recommendItem.title}
                      </span>
                      <span className="news-public-date">
                        ({dateFormat(recommendItem.publishTime)})
                      </span>
                    </p>
                  </div>
                );
              })}
            {xy_home_slip.length > 0 && (
              <PopAdvertisement banner={xy_home_slip[0]} move={true} />
            )}
          </Col>
        </Row>

        {/* 新闻区域 */}
        <Row className="news-module">
          {modules?.news.map((newCard, index) => {
            return newCard.child && newCard.child.length > 0 ? (
              <Col
                className="new-module-col"
                span={12}
                key={newCard.secondColumnId}
              >
                <Card
                  className="module-card"
                  title={newCard.secondColumnName}
                  bordered={false}
                  extra={
                    <span
                      onClick={() => onNewsListClick(newCard.secondColumnId)}
                    >
                      更多
                      <img src={entryIcon} alt="" />
                    </span>
                  }
                >
                  <p className="cover">
                    <img
                      src={
                        xy_home_bottom[index] && xy_home_bottom[index].imageUrl
                      }
                      alt=""
                      onClick={() => {
                        xy_home_bottom[index].url &&
                          window.open(xy_home_bottom[index].url);
                      }}
                      width={"100%"}
                    />
                  </p>
                  <ul>
                    {newCard.child.map((newItem) => {
                      return (
                        <li
                          className="new-item"
                          onClick={() => onNewsDetailsClick(newItem)}
                          key={newItem.newsId}
                        >
                          <span className="new-title">
                            <i></i>
                            {newItem.title}
                          </span>
                          <span className="news-public-date">
                            {dateFormat(newItem.publishTime)}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </Card>
              </Col>
            ) : null;
          })}
        </Row>

        {/* 视频课程区域 */}
        <div className="video-course-module">
          <Card
            className="module-card"
            title="培训课程"
            bordered={false}
            extra={
              <span onClick={onVideoCoursesMoreClick}>
                更多
                <img src={entryIcon} alt="" />
              </span>
            }
          >
            <Row gutter={[38.54, 0]}>
              {videoCoursesList &&
                videoCoursesList.map((item: VideoCourseItem) => {
                  return (
                    <Col
                      span={6}
                      className="course-item"
                      key={item.id}
                      onClick={() => onVideoCourseClick(item.id)}
                    >
                      <img src={item.imageAllPath} alt="" />
                      <div className="course-info">
                        <p className="course-count-duration">
                          <span>视频：{item.videoCount}个</span>
                          <span>时长：{item.courseDurationText}</span>
                        </p>
                        <p className="video-name">{item.name}</p>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </Card>
        </div>
        <ShowConfirm
          showConfirm={showConfirm}
          setShowConfirm={setShowConfirm}
          setShowConfirmUserInfo={setShowConfirmUserInfo}
        />
        <ConfirmUserInfo
          setShowConfirmUserInfo={setShowConfirmUserInfo}
          showConfirmUserInfo={showConfirmUserInfo}
        />
      </div>
    </div>
  );
}
